(ns common.schema.entities.survey.survey-sharing-type
  "Whether a respondent may pass their survey on to someone else.

   `:sharing-type/requires-approval` differs from the rest in needing a
   decision from us: it raises a task for the profile's contact, and the
   invitation is only sent once that is approved.")

(def options
  [{:key   :sharing-type/free-sharing
    :ord   0.0
    :label "Share freely"}
   {:key   :sharing-type/same-domain-only
    :ord   1.0
    :label "Only to same domain"}
   {:key   :sharing-type/allowed-domains
    :ord   2.0
    :label "Listed domains only"}
   {:key   :sharing-type/requires-approval
    :ord   3.0
    :label "Anyone, with our approval"}
   {:key   :sharing-type/not-allowed
    :ord   4.0
    :label "Not allowed"}])

(def by-key
  (->> options
       (map (juxt :key identity))
       (into {})))

(defn label
  [sharing-type]
  (:label (get by-key sharing-type)))
